import { render } from "./ProsesPDOMonev.vue?vue&type=template&id=3c53c44a"
import script from "./ProsesPDOMonev.vue?vue&type=script&lang=js"
export * from "./ProsesPDOMonev.vue?vue&type=script&lang=js"

import "./ProsesPDOMonev.vue?vue&type=style&index=0&id=3c53c44a&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__